import axios from 'axios'

const { REACT_APP_ENDPOINT } = process.env;
const ENDPOINT = `${REACT_APP_ENDPOINT}/api/Client/`


export default class datosCliente {
    static async getClientData(clienteId) {
        const respuesta = await axios.get(`${ENDPOINT}GetClientData/${clienteId}`)
        .then(response => {
            return response
        })
        return respuesta.data.data
    }

    static async getContactoPorTipoEmail(clienteId, tipoEmailId) {
        const respuesta = await axios.get(`${ENDPOINT}GetContactoPorTipoEmail/${clienteId}/${tipoEmailId}`)
        .then(response => {
            return response
        })
        return respuesta.data.data
    }

    static async getTiendaByCliente(clienteId) {
        const respuesta = await axios.get(`${ENDPOINT}GetTiendasByCliente/${clienteId}`)
        .then(response => {
            return response
        })
        return respuesta.data.data
    }

    static async createContacto(contacto){
        try {
            const respuesta = await axios.post(`${ENDPOINT}CreateContacto`, contacto);
            return respuesta.data;
        } catch (error) {
            throw error;
        }
    }
    static async updateContacto(contacto){
        try {
            const respuesta = await axios.post(`${ENDPOINT}UpdateContacto`, contacto);
            return respuesta.data;
        } catch (error) {
            throw error;
        }
    }
    static async deleteContacto(contacto){
        try {
            const respuesta = await axios.post(`${ENDPOINT}DeleteContacto`, contacto);
            return respuesta.data;
        } catch (error) {
            throw error;
        }
    }
}